<template>
    <div class="">
        <group-page-header title="Shared Media Folders">
            <span slot="additionalButtons">
                <toggle-edit-mode-button v-if="viewer_state.is_admin" v-model="editMode"></toggle-edit-mode-button>
            </span>
        </group-page-header>
        <div class="shared-list__container">
            <rectangle-stuff-preview
                    v-for="folder in results"
                    :key="folder.id"
                    :to="folder.link | backHrefQuery"

                    :name="folder.name"
                    :avatar="folder.avatar"
                    :media-content-samples="folder.media_content_samples"

                    color-class="folder"
                    :super-avatar="folder.owner?folder.owner.avatar:undefined"
                    :unread-mark="folder.is_unread"
                    :deletable="editMode"
                    :size="previewSize"
                    @delete="unshareFolder(folder.id)"
            ></rectangle-stuff-preview>
            <div
                    :style="swamFakeIconStyle"
                    v-for="fakeItem in swamGetFakeItems(results.length)"
                    :key="fakeItem.id"
            ></div>
        </div>
        <div class="alert alert-info margin-15-top" v-if="initialized&&!results.length">There are not any Media shared
            with this Group yet.
        </div>
        <div v-infinite-scroll="loadMore"></div>
    </div>
</template>

<script>
    import InfiniteScrollMixin from "../../../../vue/mixins/InfiniteScrollMixin";
    import RectangleStuffPreview from "../../../../vue/common_components/RectangleStuffPreview";
    import Vue from "vue";
    import {mapGetters} from "vuex";
    import SelfWidthAwareMixin from "../../../../vue/mixins/SelfWidthAwareMixin";
    import ItemSizingMixin from "./ItemSizingMixin";
    import GroupPageHeader from "../common/GroupPageHeader";
    import ToggleEditModeButton from "../common/ToggleEditModeButton";

    export default {
        name: "GroupPageSharedListMedia",
        components: {ToggleEditModeButton, GroupPageHeader, RectangleStuffPreview},
        mixins: [InfiniteScrollMixin, SelfWidthAwareMixin, ItemSizingMixin],
        data() {
            return {
                limit: 24,
                editMode: false,
            };
        },
        computed: {
            ...mapGetters('groupPage', {group: 'group', viewer_state: 'viewer_state'}),
        },
        methods: {
            getListEndpointArgs() {
                return [this.group.id];
            },
            getListEndpoint() {
                const GroupResource = Vue.getAngularModule('GroupResource');
                return GroupResource.get_shared_media_folders;
            },
            unshareFolder(folderId) {
                const $rootScope = Vue.getAngularModule('$rootScope');
                const simplePopupFactory = Vue.getAngularModule('simplePopupFactory');
                const GroupResource = Vue.getAngularModule('GroupResource');
                simplePopupFactory.show_popup(
                    `Remove Media Folder share from Group`,
                    `Are you sure you want to remove this Media Folder from the sharing list?`,
                    'Remove',
                    'No',
                    'btn-red'
                )
                    .then(r => {
                        $rootScope.show_dimmer();
                        return GroupResource.unshare(this.this.group.id, 'ifolder', folderId);
                    }, () => new Promise(() => {
                    }))
                    .then(resp => {
                        Vue.notifications.success('Deleted');
                        this.results = this.results.filter(f => f.id !== folderId);
                    }, err => Vue.notifications.error(err || 'Error'))
                    .finally($rootScope.hide_dimmer);
            }
        }
    };
</script>

<style scoped lang="scss">
  @import "common-styles";
  @import "../commonStyle";
</style>
